/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { InAppPageRule, RuleOperator, RULE_OPERATORS_OPTIONS, InAppPlatform } from 'cio/utils/in-app/message-config';

const PLATFORMS: Record<InAppPlatform, { icon: string; label: string }> = {
  web: { icon: 'desktop', label: 'Web' },
  ios: { icon: 'apple', label: 'iOS' },
  android: { icon: 'android', label: 'Android' },
};

interface RuleDefinitionArgs {
  index: number;
  rule: InAppPageRule;
  disabled: boolean;
  onDelete: (index: number) => unknown;
  onChange: (index: number, operator: RuleOperator, value: string, platform: InAppPlatform) => unknown;
}

export default class RuleDefinition extends Component<RuleDefinitionArgs> {
  @tracked isTouched = false;

  readonly operators = RULE_OPERATORS_OPTIONS;

  get platformItems() {
    return Object.entries(PLATFORMS).map(([value, { label }]) => ({ value, label }));
  }

  get selectedPlatformIcon() {
    return PLATFORMS[this.args.rule.platform].icon;
  }

  get placeholder() {
    switch (this.args.rule.platform) {
      case 'web':
        return '/dashboard';
      default:
        return 'Dashboard';
    }
  }

  get errors() {
    return this.args.rule.errors;
  }

  get showErrors() {
    let { rule, disabled } = this.args;
    return !disabled && this.isTouched && rule.hasErrors;
  }

  @action
  markAsTouched() {
    if (!this.isTouched) {
      this.isTouched = true;
    }
  }

  @action
  setOperator(operator: RuleOperator) {
    let { rule, index } = this.args;
    this.args.onChange(index, operator, rule.value, rule.platform);
  }

  @action
  setValue(value: string) {
    let { rule, index } = this.args;
    this.args.onChange(index, rule.operator, value, rule.platform);
  }

  @action
  setPlatform(platform: InAppPlatform) {
    let { rule, index } = this.args;
    this.args.onChange(index, rule.operator, rule.value, platform);
  }

  @action
  onDelete() {
    this.args.onDelete(this.args.index);
  }
}
